import React, { useEffect, useState } from 'react'
import { MaterialReactTable, createMRTColumnHelper, useMaterialReactTable, } from 'material-react-table';
import Breadcrumb from '../../../../Components/Breadcrumb/Breadcrumb'
import EvnVar from '../../../../EnvVar';
import Cookies from 'js-cookie';
import axios from 'axios'
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Form from 'react-bootstrap/Form';
import { useRole } from '../../../../RoleContext';
import { Box, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';

function Slogan() {
    const [data, setData] = useState([])
    const baseURL = EvnVar()
    const token = Cookies.get("jwt")
    const { role } = useRole();
    // console.log("parentVariable", parentVariable);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const config = {
                    method: "get",
                    maxBodyLength: Infinity,
                    url: `${baseURL}/user/getSlogans`,
                    headers: {
                        Authorization: token,
                    },
                    withCredentials: true,
                };

                const response = await axios.request(config);
                let completResponse = response.data
                completResponse = completResponse.map(item => {
                    const { ambassador, ...rest } = item
                    return {
                        ...rest,
                        branch: ambassador.branch,
                        fullname: ambassador.fullname
                    }
                })
                setData(completResponse);
                console.log("Get Slogan =>", completResponse);
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };

        fetchData();
    }, [])

    const columnHelper = createMRTColumnHelper();

    const columns = [
        columnHelper.accessor('fullname', {
            header: 'Ambassador Name',
        }),
        columnHelper.accessor('slogan', {
            header: 'Slogan',
        }),
        columnHelper.accessor('branch', {
            header: 'Branch',
        }),
        {
            accessorFn: (row) => `${row.id} ${row.isApproved}`,
            id: 'name', //id is still required when using accessorFn instead of accessorKey
            header: 'Name',
            size: 250,
            Cell: ({ row }) => (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                    }}
                >
                    <FormControlLabel
                    control={
                        <Switch
                            checked={row.original.isApproved === 1}
                            onChange={(e) => handleSwitchValue(row.original.id, e.target.checked)}
                            disabled={role !== "admin"}
                        />
                    }
                    label=""
                />
                </Box>
            ),
        },
    ]

    const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: true,
    });

    const handleExportRows = (rows) => {
        let rowData = rows.map((row) => row.original);
        console.log('rowDAtea ', rowData)
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
    };

    const handleExportData = () => {
        console.log('data is ', data)
        const csv = generateCsv(csvConfig)(data);
        download(csvConfig)(csv);
    };


    const table = useMaterialReactTable({
        columns,
        data, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        enableRowSelection: true,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Data
                </Button>
                <Button
                    disabled={table.getPrePaginationRowModel().rows.length === 0}
                    //export all rows, including from the next page, (still respects filtering and sorting)
                    onClick={() =>
                        handleExportRows(table.getPrePaginationRowModel().rows)
                    }
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Rows
                </Button>


                <Button
                    disabled={table.getRowModel().rows.length === 0}
                    //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
                    onClick={() => handleExportRows(table.getRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Page Rows
                </Button>
                <Button
                    disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Selected Rows
                </Button>
            </Box>
        ),
    });

    const [successMessage, setSuccessMessage] = useState(null)
    const handleSwitchValue = (id, checked) => {

        let formData = JSON.stringify({
            "id": id,
            "isApproved": checked ? 1 : 0
        });

        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${baseURL}/user/approveSlogan`,
            headers: {
                'content-type': 'application/json',
                Authorization: token,
            },
            data: formData,
            withCredentials: true,
        };

        axios
            .request(config)
            .then((response) => {
                const responseData = JSON.stringify(response.data)
                const responseDataJson = JSON.parse(responseData)
                const responseMessage = responseDataJson.message
                console.log("responseData", responseMessage);
                setSuccessMessage(responseMessage)
                setTimeout(() => {
                    setSuccessMessage(null)
                }, 1000);

                setData(prevSlogan => {
                    return prevSlogan.map(item => {
                        if (item.id === id) {
                            return {
                                ...item,
                                isApproved: checked ? 1 : 0
                            };
                        }
                        return item;
                    });
                })
            })
            .catch((error) => {
                console.log("Error while fetching", error);
                // console.log(error);
            });
    };

    return (
        <>
            <Breadcrumb data="Slogan" />
            <div className='content-body'>
                {successMessage && <p className='text-success mb-0 position-absolute' style={{ top: "7rem", right: "2rem", transition: "ease-in-out 0.3s" }}>{successMessage}</p>}
                <div className="table-data">
                    <MaterialReactTable table={table} />
                    {/* <div className='table-responsive'>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th>Ambassador Name</th>
                                    <th>Slogan</th>
                                    <th>Branch</th>
                                    <th>Approval</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.map((value, index) => (
                                    <tr key={index}>
                                        <td>{value.fullname}</td>
                                        <td>{value.slogan}</td>
                                        <td>{value.branch}</td>
                                        <td>
                                            <Form>
                                                <Form.Check
                                                    type="switch"
                                                    id={`switch-${value.id}`}
                                                    disabled={role !== "admin"}
                                                    checked={value.isApproved === 1}
                                                    onChange={(e) => handleSwitchValue(value.id, e.target.checked)}
                                                />
                                            </Form>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div> */}
                </div>
            </div>
        </>
    );
}

export default Slogan
